<mat-dialog-content class="mat-typography reset-your-password">
  <div class="section_login">

    <button style="outline: none;" class="close-button forgetPass" [mat-dialog-close]="true" id="closeBtn"
      (click)="onClickBack()">
      <img src="../../../assets/icons/x-button.svg">
    </button>

    <div class="row" *ngIf="showreset">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7  ">
        <div class="container_login add-your-organization reset-pass">
          <div class="text-block " [id]="'textBlock_'">
            <h4 class="colgin_headerText"> {{data.userType.titleOne}}<br><span
                class="loginP_textTwo">{{data.userType.titleTwo}}</span></h4>
            <p class="login_textP">{{data.userType.text}}</p>
          </div>
        </div>
      </div>


      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5" style=" display: grid; place-items: center; ">
        <div class="form_section">
          <div class="row">
            <div class="col-sm-12">
              <img src="../../../assets/SVG/logo.svg" class="w-161">
            </div>
            <div class="col-sm-12">
              <p class="authHeadText" style="font-family: sora !important;">Reset your Password</p>
              <p class="resetPassText" style="font-family: sora !important;">Enter the email address associated with
                your account and we will send you the new
                password.</p>
            </div>
            <div class="col-sm-12">
              <form class="signIn_form" [formGroup]="resetForm">
                <mat-form-field class="example-full-width">
                  <mat-label><mat-icon><img src="../../../assets/SVG/mail.svg"
                        style="display: flex;" class="position-absolute"></mat-icon>&nbsp;&nbsp;&nbsp;&nbsp; <span
                      *ngIf="!resetForm.value.email">Enter email</span>
                  </mat-label>
                  <input matInput placeholder="" formControlName="email">
                </mat-form-field>
                <!-- <div *ngIf="submitReset && c['email'].errors" class="form-error">
                  <div *ngIf="c['email'].errors['required']">*Email required</div>
                  <div *ngIf="c['email'].errors['pattern']">*Enter a valid Email Address</div>
                </div> -->
                <div *ngIf="resetForm.value.email && resetForm.invalid" class="form-error">
                  Enter a valid Email Address
                </div>

                <div class="col-sm-12">
                  <button mat-raised-button color="warn" class="authSignIn" (click)="onClickReset()"
                    [disabled]="resetForm.invalid">Reset Password</button>
                  <p class="SignupAsk" style="font-family: sora !important;"> Back to <span class="signupFNCSS"
                      [mat-dialog-close]="true" (click)="backToSignIn()"
                      style="cursor: pointer; font-size: 16px !important;">Sign In</span></p>
                </div>
              </form>


            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section_login" *ngIf="!showreset">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7  ">
          <div class="container_login add-your-organization reset-pass">
            <img src="../../../assets/image/email-sent.png" height="500px" width="650" alt="Nature"
              style="width:100%; border-radius: 10px !important;">
            <div class="text-block " [id]="'textBlock_'">
              <h4 class="colgin_headerText"> {{data.userType.titleOne}}<br><span
                  class="loginP_textTwo">{{data.userType.titleTwo}}</span></h4>
              <p class="login_textP">{{data.userType.text}}</p>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5">
          <div class="form_section">
            <div class="row">
              <div class="col-sm-12">
                <img src="../../../assets/SVG/logo.svg" class="w-161">
              </div>
              <div class="col-sm-12">
                <p class="authHeadText" style="font-family: sora !important;">Email has been sent.</p>
                <p class="resetPassText" style="font-family: sora !important;">Please check your inbox. We have sent a
                  new password to your email address.</p>
              </div>
              <div class="col-sm-12">


                <button mat-raised-button color="warn" class="authSignIn" [mat-dialog-close]="true"
                  (click)="backToSignIn()">Log in</button>
                <p class="SignupAsk" style="font-family: sora !important;"> Didn’t receive the email? <span
                    class="signupFNCSS" style="cursor: pointer;" [ngClass]="{'disabledResend':disabledResend==true}"
                    (click)="resendClick()">Resend</span>
                  <span id="time" class="signupFNCSS" *ngIf="disabledResend==true"
                    style="margin-left: 20px;font-family: sora !important;"></span>
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



</mat-dialog-content>